import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useDevice } from '../../providers/Device';
import styles from './Grid.module.scss';
export function Grid(_0) {
    let { className, rowGap = 'large', rowGapMobile, align = 'start', testId } = _0, rest = _object_without_properties(_0, [
        "className",
        "rowGap",
        "rowGapMobile",
        "align",
        "testId"
    ]);
    const { isMobileDevice } = useDevice();
    const gapClass = styles["".concat(rowGap, "Gap")];
    const alignClass = styles["".concat(align, "Align")];
    const effectiveRowGap = rowGapMobile != null && isMobileDevice ? rowGapMobile : rowGap;
    return /*#__PURE__*/ _jsx("div", _object_spread({
        className: cn(styles.root, gapClass, alignClass, className),
        style: {
            rowGap: typeof effectiveRowGap === 'number' ? effectiveRowGap : undefined
        },
        "data-testid": testId
    }, rest));
}
